var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "body-container body_container--section_nav page-links no-images show-all-items visual_menu--glass_effect textual_menu--glass_effect",
      class: _vm.containerClasses,
    },
    [
      _c("div", { ref: "scroller", staticClass: "viewport" }, [
        _c(
          "div",
          { staticClass: "body-container-scroller" },
          _vm._l(_vm.sections || [], function (section) {
            return _c("menu-section-list-item", {
              key: "nav--" + section.ms_id,
              attrs: {
                section: section,
                "is-highlighted": _vm.navButtonHighlighted === section.ms_id,
              },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.navButtonClickHandler.apply(null, arguments)
                },
              },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "page-link-view-more btn", attrs: { href: "#" } },
          [_vm._v("VIEW MORE")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }